module.exports = __webpack_public_path__ + "static/media/Bhavin Patel.6c5428bc.jpg";